import wrapInObserver from '../wrapInObserver';
import Filter from './Filter';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import { groupIds } from '../../constants/uiParams';
import FilterMobile from './FilterMobile';

const { useUiStore, useRootStore } = generatedHooks;

const mapProps = () => {
  try {
    const uiStore = useUiStore(store => store);
    const {
      verified,
      autopark,
      atiOrders,
      atiDocs,
      confirmedContacts,
      epdMedal,
      setVerified,
      setAutopark,
      setAtiOrders,
      setAtiDocs,
      setConfirmedContacts,
      setEpdMedal,
      groupId,
      showAllFilters,
      setShowAllFilters,
    } = uiStore;

    const rootStore = useRootStore(store => store);

    const handleVerifiedClick = (value) => {
      setVerified(value);
      rootStore.reload();
    };

    const handleAutoparkClick = (value) => {
      setAutopark(value);
      rootStore.reload();
    };

    const handleAtiOrdersClick = (value) => {
      setAtiOrders(value);
      rootStore.reload();
    };

    const handleAtiDocsClick = (value) => {
      setAtiDocs(value);
      rootStore.reload();
    };

    const handleConfirmedContactsClick = (value) => {
      setConfirmedContacts(value);
      rootStore.reload();
    };

    const handleEpdMedalClick = (value) => {
      setEpdMedal(value);
      rootStore.reload();
    };

    const firmTypeAbbreviationByTabMap = {
      [groupIds.Carrier]: 'П',
      [groupIds.Dispatcher]: 'Э',
      [groupIds.Shipper]: 'ГВ',
    };

    return {
      verified,
      autopark,
      atiOrders,
      atiDocs,
      confirmedContacts,
      epdMedal,
      handleVerifiedClick,
      handleAutoparkClick,
      handleAtiOrdersClick,
      handleAtiDocsClick,
      handleConfirmedContactsClick,
      handleEpdMedalClick,
      firmTypeAbbreviation: firmTypeAbbreviationByTabMap[groupId],
      selectedGroupId: groupId,
      showAllFilters,
      setShowAllFilters,
    };
  } catch (error) {
    logger.log(error);
    return {};
  }
};

export default wrapInObserver(Filter, mapProps, FilterMobile);
